module.exports = __webpack_public_path__ + "img/fonts.0c13a9e7.svg";